interface Props {
  /** Number of skeleton lines */
  lines?: number;
}

/**
 * Loading skeleton for modal content. Shows N rows of shimmer placeholders.
 */
export function ModalSkeleton({ lines = 4 }: Props) {
  return (
    <div
      role="status"
      aria-label="불러오는 중"
      style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
    >
      {Array.from({ length: lines }, (_, i) => (
        <div
          key={i}
          style={{
            height: 16,
            width: `${60 + ((i * 13) % 35)}%`,
            borderRadius: 4,
            background:
              'linear-gradient(90deg, var(--shimmer-base) 0%, var(--shimmer-highlight) 50%, var(--shimmer-base) 100%)',
            backgroundSize: '200% 100%',
            animation: 'tableSkeletonShimmer 1.5s ease-in-out infinite',
          }}
        />
      ))}
    </div>
  );
}
